import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-daily-status-view",
    templateUrl: "./daily-status-view.component.html",
    styleUrls: ["./daily-status-view.component.css"],
})
export class DailyStatusViewComponent implements OnInit {
    now: Date;
    daysArray = [];
    days: number;
    monthlyVolume: any;
    pieChartData: any;
    lineChartHourlyTransaction: any;
    barChartTopTenTpVolume: any;
    barChartFailureRates: any;
    userRole: string;

    constructor(
        private http: HttpClient,
        public session: SessionStorageService,
        public localstorage: LocalStorageService,
        private router: Router
    ) {}

    ngOnInit() {
        this.userRole = this.session.retrieve("userRole");
        this.daysArray.push({ label: "30", value: "30" });
        this.daysArray.push({ label: "31", value: "31" });
        this.daysArray.push({ label: "28", value: "28" });
        this.daysArray.push({ label: "15", value: "15" });
        this.daysArray.push({ label: "7", value: "7" });
        this.daysArray.push({ label: "1", value: "1" });
        this.days = 30;
        this.getTransactionVolumes();
        this.getHourlyVolumes();
        this.monthlyVolumes(this.days);
        this.getDailyFailureRate();
        this.getTopTenTpVolumes();
    }

    getTransactionVolumes() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        headers.append("Content-Type", "application/json");
        this.http
            .get(environment.apiUrl + "/dashboards/dailyTransactions", {
                headers: headers,
            })
            .subscribe((transactionalVolumes: any) => {
                let transactions = [];
                let values = [];
                let colors = [];
                let groups = ["Orders", "Shipments", "Receipts"];
                let ordersCount = 0;
                let shipmentsCount = 0;
                let receiptsCount = 0;
                transactionalVolumes.forEach((transaction: any) => {
                    if (transaction.type == 940 || transaction.type == 1080) {
                        ordersCount = ordersCount + transaction.count;
                    } else if (
                        transaction.type == 945 ||
                        transaction.type == 856
                    ) {
                        shipmentsCount = shipmentsCount + transaction.count;
                    } else if (transaction.type == 943) {
                        receiptsCount = receiptsCount + transaction.count;
                    }
                });
                groups.forEach((group: string) => {
                    transactions.push(group);
                    if (group == "Orders") {
                        values.push(ordersCount);
                        colors.push("#20B2AA");
                    } else if (group == "Shipments") {
                        values.push(shipmentsCount);
                        colors.push("#DEB887");
                    } else if (group == "Receipts") {
                        values.push(receiptsCount);
                        colors.push("#778899");
                    }
                });
                this.pieChartData = {
                    labels: transactions,
                    datasets: [
                        {
                            data: values,
                            backgroundColor: colors,
                        },
                    ],
                };
            });
    }

    getHourlyVolumes() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        headers.append("Content-Type", "application/json");
        this.http
            .get(environment.apiUrl + "/dashboards/hourlyVolumes", {
                headers: headers,
            })
            .subscribe((hourlyTransactions: any) => {
                let times = [];
                let values = [];
                hourlyTransactions.forEach((record: any) => {
                    times.push(record.hour);
                    values.push(record.count);
                });

                this.lineChartHourlyTransaction = {
                    labels: times,
                    datasets: [
                        {
                            label: "",
                            data: values,
                            fill: false,
                            borderColor: "#1E88E5",
                            max: Math.max.apply(Math, values),
                            min: 0,
                        },
                    ],
                };
            });
    }

    getDailyFailureRate() {
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        headers.append("Content-Type", "application/json");
        this.http
            .get(environment.apiUrl + "/dashboards/dailyFailureRate", {
                headers: headers,
            })
            .subscribe((dailyFailureRateData: any) => {
                let types = [];
                let values = [];
                let colors = [];
                dailyFailureRateData.forEach((response: any) => {
                    types.push(response.status);
                    values.push(response.count);
                    if (response.status === "Success") {
                        colors.push("#00FF00");
                    } else if (response.status === "Failure") {
                        colors.push("#FF4D4D");
                    } else if (response.status === "Pending") {
                        colors.push("#87CEEB");
                    }
                });
                this.barChartFailureRates = {
                    labels: types,
                    datasets: [
                        {
                            backgroundColor: colors,
                            data: values,
                        },
                    ],
                };
            });
    }

    monthlyVolumes(days: number) {
        this.monthlyVolume = {};
        let dates = [];
        let ibs = [];
        let obs = [];
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        headers.append("Content-Type", "application/json");
        this.http
            .get(environment.apiUrl + "/dashboards/monthlyVolumes/" + days, {
                headers: headers,
            })
            .subscribe((response: any) => {
                response.forEach((e: any) => {
                    dates.push(e.day);
                    ibs.push(e.ib);
                    obs.push(e.ob);
                });
                if (dates.length >= days) {
                    this.monthlyVolume = {
                        labels: dates,
                        datasets: [
                            {
                                label: "IB",
                                backgroundColor: "#42A5F5",
                                borderColor: "#1E88E5",
                                data: ibs,
                            },
                            {
                                label: "OB",
                                backgroundColor: "#5C5C61",
                                borderColor: "#5C5C61",
                                data: obs,
                            },
                        ],
                    };
                }
            });
    }

    getTopTenTpVolumes() {
        setInterval(() => {
            this.now = new Date();
        }, 1);
        let headers = new HttpHeaders();
        headers = headers.append(
            "authorization",
            this.localstorage.retrieve("token")
        );
        this.http
            .get(environment.apiUrl + "/dashboards/topTenTradingPartners", {
                headers: headers,
                responseType: "text",
            })
            .subscribe((topTenTp) => {
                this.http
                    .get(
                        environment.apiUrl +
                            "/dashboards/topTpInboundCount/" +
                            topTenTp,
                        { headers: headers }
                    )
                    .subscribe((topTenTpEdiInboundCount: any) => {
                        this.http
                            .get(
                                environment.apiUrl +
                                    "/dashboards/topTpOutboundCount/" +
                                    topTenTp,
                                { headers: headers }
                            )
                            .subscribe((topTenTpEdiOutboundCount: any) => {
                                this.barChartTopTenTpVolume = {
                                    labels: topTenTp.split(","),
                                    datasets: [
                                        {
                                            label: "IB",
                                            backgroundColor: "#42A5F5",
                                            data: topTenTpEdiInboundCount,
                                        },
                                        {
                                            label: "OB",
                                            backgroundColor: "#5C5C61",
                                            data: topTenTpEdiOutboundCount,
                                        },
                                    ],
                                };
                            });
                    });
            });
    }

    selectData(e: any) {
        let data = this.barChartFailureRates.labels[e.element._index];
        this.router.navigate(["status", { isback: data }]);
    }
    transactionData(e: any) {
        let trpdata = this.pieChartData.labels[e.element._index];
        this.router.navigate(["Transactiongroup", { isback: trpdata }]);
    }

    total() {
        let cont = 10;
    }
}
